(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneFooterPreFooter"] = factory();
	else
		root["@makolab/library-react/dist/OneFooterPreFooter"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 343);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Link");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Prefooter", function() { return Prefooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Link__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prefooter_jss__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prefooter_types__ = __webpack_require__(345);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Prefooter=function(_Component){_inherits(Prefooter,_Component);function Prefooter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Prefooter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Prefooter.__proto__||Object.getPrototypeOf(Prefooter)).call.apply(_ref,[this].concat(args))),_this),_this.renderItemText=function(_ref2){var className=_ref2.className,text=_ref2.text;var classes=_this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes[className]),component:'span',variant:'body1'},text);},_this.renderItem=function(_ref3){var url=_ref3.url,newTab=_ref3.newTab,icon=_ref3.icon,mainText=_ref3.mainText,secondaryText=_ref3.secondaryText;var classes=_this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Link___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.elemContent),href:url,target:newTab?'_target':'_self',underline:'none',variant:'body2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.icon)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.img),src:icon,alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.text)},_this.renderItemText({className:'mainText',text:mainText}),_this.renderItemText({className:'secondaryText',text:secondaryText})));},_this.renderSpanItem=function(_ref4){var icon=_ref4.icon,mainText=_ref4.mainText,secondaryText=_ref4.secondaryText;var classes=_this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.elemContent)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.icon)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.img),src:icon,alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.text)},_this.renderItemText({className:'mainText',text:mainText}),_this.renderItemText({className:'secondaryText',text:secondaryText})));},_temp),_possibleConstructorReturn(_this,_ret);}/*
    Use to put element which is not a link
   */_createClass(Prefooter,[{key:'render',value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,prefooter=_props.prefooter;var subcomponents=prefooter.subcomponents;if(!subcomponents){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root)},subcomponents.map(function(elem,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.elem)},elem&&elem.url&&_this2.renderItem(elem),elem&&!elem.url&&_this2.renderSpanItem(elem));}));}}]);return Prefooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Prefooter.displayName='Prefooter';Prefooter.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,prefooter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__prefooter_types__["a" /* PREFOOTER_PROP_TYPE */]).isRequired};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_7__prefooter_jss__["a" /* default */])])(Prefooter));

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(theme){var themeName=theme.themeName;return{root:_defineProperty({display:'flex',flexFlow:'row wrap',justifyContent:'space-between',backgroundColor:themeName==='Renault One'?theme.palette.common.footerHead:'#FFF',margin:0,padding:0},theme.breakpoints.up('sm'),{flexWrap:'nowrap',width:'auto',flexBasis:'100%',padding:'0 '+theme.spacing.unit*4+'px'}),elem:_defineProperty({margin:0,marginBottom:theme.spacing.unit,width:'calc(50% - '+theme.spacing.unit+'px)',display:'flex',flexDirection:'row',flex:'0 1 auto',justifyContent:'center'},theme.breakpoints.up('sm'),{width:'100%'}),elemContent:{padding:'16px',display:'block'},icon:{position:'relative',marginBottom:8,height:'30px',display:'block',textAlign:'center'},img:{position:'absolute',marginTop:0,top:'50%',left:'50%',transform:'translate(-50%,-50%)',maxHeight:'100%',height:'100%',width:'auto'},text:{margin:0,textAlign:'center'},mainText:_defineProperty({margin:'0 '+theme.spacing.unit/2+'px '+theme.spacing.unit+'px 0',color:themeName==='Renault One'?theme.palette.common.darkPreF:'#000',display:'block',fontWeight:themeName==='Renault One'?700:500},theme.breakpoints.up('md'),{marginRight:0}),secondaryText:_defineProperty({color:themeName==='Renault One'?theme.palette.common.darkPreF:'#000'},theme.breakpoints.down('xs'),{display:'none'})};});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PREFOOTER_SUBCOMPONENT_PROP_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PREFOOTER_PROP_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var PREFOOTER_SUBCOMPONENT_PROP_TYPE={'@id':__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,newTab:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,mainText:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,secondaryText:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};var PREFOOTER_PROP_TYPE={'@id':__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,subcomponents:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(PREFOOTER_SUBCOMPONENT_PROP_TYPE)).isRequired};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Typography");

/***/ })

/******/ });
});
//# sourceMappingURL=OneFooterPreFooter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneFooterPreFooter.js
// module id = 598
// module chunks = 0